export default function NotAuthorized(){
    return(
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <h1>Not Authorized</h1>
            <p>You are not authorized to view this page.</p>
        </div>
    )
}